import Base from 'app/models/base';

import moment from 'moment';
import { getStoredValue } from 'utils/storage';
import { appUrl } from 'utils/wrappers';
import { trimMoney, stringToNumber } from 'utils/strings';

export const PLAN_PRODUCT_TYPE_READABLE = {
  rating: 'Rating',
  shipping: 'Shipping',
  tracking: 'Tracking',
  intl_address_verification: 'International Address Verification',
  us_address_verification: 'US Address Verification',
};

export default Base.extend({
  urlRoot: appUrl('subscriptions'),
  initialize() {
    this.set('plan', JSON.parse(getStoredValue('epsubplan')));
  },
  nextPaymentDate() {
    const plan = this.get('plan');
    const nextBillingDate = moment.utc().add(1, plan.interval);

    if (plan.interval === 'month') {
      // bill at beginning of month
      return nextBillingDate.startOf('month');
    }

    return nextBillingDate;
  },
  nextPaymentDateFormatted() {
    return this.nextPaymentDate().format('MMMM DD, YYYY');
  },
  proratedFirstPayment() {
    const plan = this.get('plan');
    if (plan.interval === 'month') {
      const proratedDays = this.nextPaymentDate().diff(moment.utc(), 'days');
      const proratedAmount = proratedDays * stringToNumber(plan.price) / moment.utc().endOf('month').date();
      return trimMoney(proratedAmount.toString(), 'USD');
    }
    return trimMoney(plan.price.toString(), 'USD');
  },
  getPlanProductReadable() {
    return PLAN_PRODUCT_TYPE_READABLE[this.get('plan_product_type')];
  },
});



// WEBPACK FOOTER //
// ./app/models/subscription.js